import $http from './http.js'
// const baseUrl = 'http://192.168.132.93:8081/api/v1/public/'
const baseUrl = '/api/v1/public/'
//获取产品文档
export const queryDoc = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}documents`,
        method: "get",
        params,
    })
}
// 校验手机是否咨询过
export const queryPhone = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}consultation/verify`,
        method: "get",
        params,
    })
}
//获取验证码
export const sendCode = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}sms/sendcode`,
        method: "post",
        params,
    })
}
//校验验证码
export const verifyCode = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}sms/verifycode`,
        method: "post",
        params,
    })
}
// 咨询建议
export const sendConsultation = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}consultation`,
        method: "post",
        data: params,
    })
}

//获取-关于我们模块
export const queryAppList = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}join`,
        method: "get",
        params,
    })
}
//获取新闻列表
export const queryNewsList = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}news`,
        method: "get",
        params,
    })
}
//获取新闻详情
export const queryNewsDetail = (id, headers) => {
    return $http({
        headers,
        url: `${baseUrl}content/${id}`,
        method: "get",
    })
}
//联系我们
export const queryContactList = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}contact`,
        method: "get",
        params,
    })
}
// 获取案例分类
export const queryCaseCategory = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}casecategories`,
        method: "get",
        params,
    })
}
// 根据案例类型查询案例列表
export const queryListByCategory = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}cases`,
        method: "get",
        params,
    })
}

// 查询案例详情
export const queryCaseDetail = (id, headers) => {
    return $http({
        headers,
        url: `${baseUrl}cases/${id}`,
        method: "get",
    })
}
// 获取最新活动
export const queryActiveList = (params, headers) => {
    return $http({
        headers,
        url: `${baseUrl}latestactivities`,
        method: "get",
        params,
    })
}
// 获取下载文档列表
export const queryDocList = (headers) => {
    return $http({
        headers,
        url: `${baseUrl}documenttitles`,
        method: "get",
    })
}